export const playlist = [
    {
        id: 0,
        title: "The F Word",
        artist: "Bugged",
        duration: "3:03",
        artwork: "",
        url: "./playlist/Bugged - The F-Word.mp3"   
    },
    {
        id: 1,
        title: `Don't Sweat The Technique`,
        artist: `Eric B. & Rakim`,
        duration: "3:19",
        artwork: "",
        url: `./playlist/Eric B. & Rakim - Don't Sweat The Technique.mp3`  
    },
    {
        id: 2,
        title: "Me And The Devil",
        artist: "Gil Scott-Heron",
        duration: "5:14",
        artwork: "",
        url: "./playlist/Gil Scott-Heron - Me And The Devil.mp3"  
    },
    {
        id: 3,
        title: "Get Ur Freak On",
        artist: "Missy Elliott",
        duration: "4:04",
        artwork: "",
        url: "./playlist/Missy Elliott - Get Ur Freak On.mp3"  
    },
    {
        id: 4,
        title: "Tomorrow",
        artist: "Sauf Keita",
        duration: "5:11",
        artwork: "",
        url: "./playlist/Sauf Keita - Tomorrow.mp3"  
    },
    {
        id: 5,
        title: "Rock Steady",
        artist: "Sweeps",
        duration: "2:21",
        artwork: "",
        url: "./playlist/Sweeps - Rock Steady.mp3"  
    },
    {
        id: 6,
        title: "Lateralus",
        artist: "TOOL" ,
        duration: "9:24",
        artwork: "" ,
        url: "./playlist/TOOL - Lateralus.mp3"  
    },
    {
        id: 7,
        title: "Juicy",
        artist: "The Notorious B.I.G" ,
        duration: "4:45",
        artwork: "" ,
        url: "./playlist/The Notorious B.I.G. - Juicy.mp3"  
    },
    {
        id: 8,
        title: "Gold",
        artist: "Chet Faker" ,
        duration: "9:24",
        artwork: "" ,
        url: "./playlist/Chet Faker - Gold.mp3"  
    }
];